import { render, staticRenderFns } from "./not-active.vue?vue&type=template&id=f264e730&scoped=true&"
import script from "./not-active.vue?vue&type=script&lang=js&"
export * from "./not-active.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f264e730",
  null
  
)

export default component.exports